import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  activateForm,
  duplicateForm,
  fetchFilledForms,
  fetchFormsGroups,
  removeForm,
  updateForm,
} from "../../redux/actions";
import { NavLink, Redirect } from "react-router-dom";
import Can from "../../components/can";
import PageTitle from "../../components/page-title";
import { Box, Paper } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { checkPermission } from "../../rbac";
import SingleGroupRow from "./single-group-row";
import styled from "styled-components";
import { brand } from "../../theme";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const GreenButton = styled(Button)`
  background-color: ${brand.teal};
`;

const GroupsPage = ({
  history,
  orgForms,
  orgFormsGroups,
  loggedIn,
  removeForm,
  fetchFilledForms,
  fetchFormsGroups,
  filledForms,
  updateForm,
  activateForm,
  duplicateForm,
}) => {
  const roles = useSelector((s) => s.roles);
  const formsGroups = useSelector((s) => s.orgFormsGroups);
  const canAddGroup = checkPermission("admin:addGroup", roles);
  const canFetchGroups = checkPermission("groups:fetch", roles);

  const classes = useStyles();

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [multiplier, setMultiplier] = useState(null);
  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    if (loggedIn && canFetchGroups) {
      fetchFormsGroups();
    }
  }, [loggedIn, fetchFormsGroups, canFetchGroups]);

  useEffect(() => {
    if (dimensions.height > 800 || dimensions.height === 800) {
      setMultiplier(dimensions.height * 0.00075);
    } else if (dimensions.height < 800 && dimensions.height > 700) {
      setMultiplier(dimensions.height * 0.00085);
    } else if (dimensions.height < 701 && dimensions.height > 580) {
      setMultiplier(dimensions.height * 0.00095);
    } else {
      setMultiplier(dimensions.height * 0.0011);
    }
  }, [dimensions]);

  const page = () => (
    <Box>
      <Box p={1}>
        <PageTitle title="Projekty" />
      </Box>
      <Box p={1}>
        <TableContainer
          component={Paper}
          style={{ maxHeight: dimensions.height * multiplier }}
        >
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nazwa</TableCell>
                <TableCell>Opis</TableCell>
                <TableCell>Wiadomość SMS</TableCell>
                <TableCell>Numer telefonu</TableCell>
                <TableCell>Wiadomość Email</TableCell>
                <TableCell>Opcje projektu</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formsGroups.map((formsGroup, index) => {
                return <SingleGroupRow key={index} group={formsGroup} />;
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Can
          permission="admin:addGroup"
          ok={() => (
            <Box position="fixed" bottom={20} right={25}>
              <NavLink to="/form_group/add">
                <GreenButton variant="contained" color="primary">
                  + Dodaj Nowy projekt
                </GreenButton>
              </NavLink>
            </Box>
          )}
        />
      </Box>
    </Box>
  );

  const redirect = () => <Redirect to="/" />;

  return <Can permission="groups-page:view" ok={page} not={redirect} />;
};

const mapStateToProps = (state) => ({
  organization: state.organization,
  orgForms: state.orgForms,
  orgFormsGroups: state.orgFormsGroups,
  loggedIn: state.loggedIn,
  filledForms: state.filledForms,
});

const mapDispatchToProps = (dispatch) => ({
  activateForm: (form) => dispatch(activateForm(form)),
  removeForm: (formId) => dispatch(removeForm(formId)),
  fetchFilledForms: (formId) => dispatch(fetchFilledForms(formId)),
  fetchFormsGroups: () => dispatch(fetchFormsGroups()),
  updateForm: (id, payload) => dispatch(updateForm(id, payload)),
  duplicateForm: (id) => dispatch(duplicateForm(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupsPage);
